/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyExecuteResponse {
    getFixupPrototypeFunction() { return PolicyExecuteResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyExecuteResponse>): PolicyExecuteResponse {
        let obj = Object.assign(new PolicyExecuteResponse(), model);
        PolicyExecuteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyExecuteResponse>): PolicyExecuteResponse {
        if (!model) return null;
        return PolicyExecuteResponse.newInstance(<PolicyExecuteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyExecuteResponse) {
        if (!obj) return;

        models.PolicyExecuteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyExecuteResponse): boolean {
        Object.setPrototypeOf(obj, PolicyExecuteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Job identifier of the executed policy
     */
    job_id: string;

}
